import {
  Directive,
  ElementRef,
  inject,
  Input,
  OnChanges,
} from '@angular/core';

@Directive({
  selector: '[issTabIndex]',
  standalone: true,
})
export class TabIndexDirective implements OnChanges {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input('issTabIndex') public tabIndex?: number | null;

  public ngOnChanges(): void {
    const { nativeElement } = this.elementRef;
    return this.tabIndex == null
      ? nativeElement.removeAttribute('tabIndex')
      : nativeElement.setAttribute('tabIndex', String(this.tabIndex));
  }
}
